import React from "react";
import EditableProject from "@/components/projects/editing/EditableProject";
import SimplePage from "@/components/structure/SimplePage";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router";

export default function CreateProject() {
  return (
    <SimplePage title="Create New Project">
        <div className="mb-8">
          <NavLink to="/" replace className="text-blue-600 hover:underline ml-2">
          ← Return Home
          </NavLink>
        </div>

        <EditableProject />
    </SimplePage>
  );
}
